var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJcbIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.205566 16H4.72342C5.75124 16 6.98235 14.8053 6.98235 13.8667V0H2.46449C1.43668 0 0.205566 1.19467 0.205566 3.2V16Z",
    fill: "#047AB1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76945 10.816C1.90211 10.8162 1.03905 10.7013 0.205566 10.4747V9.30137C0.852355 9.67908 1.59167 9.89221 2.35155 9.92004C3.22124 9.92004 3.70691 9.34404 3.70691 8.55471V5.33337H5.85289V8.55471C5.85289 9.81337 5.15262 10.816 2.76945 10.816Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11182 16H12.6297C13.6575 16 14.8886 14.8053 14.8886 13.8667V0H10.3707C9.34293 0 8.11182 1.19467 8.11182 3.2V16Z",
    fill: "#D42D06"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11182 6.08005C8.76691 5.48272 9.89637 5.10939 11.7261 5.19472C12.72 5.23739 13.7591 5.51472 13.7591 5.51472V6.69872C13.1648 6.35925 12.4968 6.15137 11.8052 6.09072C10.4159 5.97339 9.56882 6.70939 9.56882 8.00005C9.56882 9.29072 10.4159 10.0267 11.8052 9.92005C12.4972 9.85399 13.1648 9.64261 13.7591 9.30139V10.4747C13.7591 10.4747 12.72 10.7627 11.7261 10.8054C9.89637 10.8907 8.76691 10.5174 8.11182 9.92005V6.08005Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0181 16H20.5359C21.5637 16 22.7949 14.8053 22.7949 13.8667V0H18.277C17.2492 0 16.0181 1.19467 16.0181 3.2V16Z",
    fill: "#67B637"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6654 9.28004C21.6654 10.1334 20.9651 10.6667 20.0277 10.6667H16.0181V5.33337H19.6662L19.926 5.34404C20.7505 5.38671 21.3604 5.84537 21.3604 6.63471C21.3604 7.25337 20.9425 7.78671 20.1858 7.91471V7.94671C21.0216 8.00004 21.6654 8.50137 21.6654 9.28004ZM18.7853 6.17604C18.7366 6.16917 18.6876 6.16561 18.6384 6.16537H17.2831V7.50937H18.7853C19.0676 7.44537 19.3048 7.20004 19.3048 6.83737C19.3048 6.47471 19.0676 6.22937 18.7853 6.17604ZM18.9547 8.35204C18.8949 8.34318 18.8344 8.33961 18.774 8.34137H17.2831V9.80271H18.774L18.9547 9.78137C19.237 9.71737 19.4742 9.44004 19.4742 9.06671C19.4742 8.69337 19.2483 8.42671 18.9547 8.35204Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcbIcon);
export default __webpack_public_path__ + "static/media/jcbIcon.2abf733d76bd63fc4ca8f6c6a2de627b.svg";
export { ForwardRef as ReactComponent };